import 'angular-server-side-configuration/process';

export const environment = {
  production: true,
};
